import type { CSSProperties, ReactNode } from 'react';
import classes from './ListPane.module.css';
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';

export default function ListPane({
  children,
  listWrapperStyles,
  listStyles,
  className,
  isLoaded = true,
}: {
  children: ReactNode;
  listWrapperStyles?: CSSProperties;
  listStyles?: CSSProperties;
  className?: string;
  isLoaded?: boolean;
}) {
  return (
    <div
      className={`${classes.listWrapper} ${className ?? ''}`}
      style={listWrapperStyles ?? {}}
      data-testid="list-grid-wrapper"
      data-testid-loaded={isLoaded ? 'true' : 'false'}
    >
      <div className={classes.list} style={listStyles ?? {}}>
        <ErrorBoundary>
          <div className={classes.listContent}>{children}</div>
        </ErrorBoundary>
      </div>
    </div>
  );
}
